import { render, staticRenderFns } from "./WinemakerData.vue?vue&type=template&id=36744d88&scoped=true&"
import script from "./WinemakerData.vue?vue&type=script&lang=ts&"
export * from "./WinemakerData.vue?vue&type=script&lang=ts&"
import style0 from "./WinemakerData.vue?vue&type=style&index=0&id=36744d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36744d88",
  null
  
)

export default component.exports